import { render, staticRenderFns } from "./TextAreaResponse.vue?vue&type=template&id=be37ffce&scoped=true&"
import script from "./TextAreaResponse.vue?vue&type=script&lang=js&"
export * from "./TextAreaResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be37ffce",
  null
  
)

export default component.exports